import React, { useContext, useEffect, useState, useRef } from 'react';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaChevronLeft, FaEye, FaThumbsDown, FaThumbsUp } from 'react-icons/fa';
import { converHtml, sendVisit } from '../services/infoService';
import { Link, useParams, useNavigate } from 'react-router';
import { API_BASE_URL } from '../config/api';
import { AppContext } from '../AppContext';
import DOMPurify from 'dompurify';
import "../assets/css/View.css";
import { Button } from '@mui/material';

interface Vinculo {
    seccion: string;
    seccion_destacada: string;
    id: string;
    id_seccion: string;
    titulo: string;
    numero_visitas: number;
    contenido: string;
    pdf_url?: string;
    id_tipo_perfil: string;
}

const View: React.FC = () => {
    const navigate = useNavigate();
    const context = useContext(AppContext);
    const localData = localStorage.getItem("data");
    const localDataParsed = JSON.parse(localData || '{}');

    const hash = localStorage.getItem("hash") || "";

    const info = context?.data?.vinculos.length > 0 ? context?.data.vinculos : localDataParsed?.vinculos || [];
    const { id } = useParams<{ id: string }>();

    const [vinculos, setVinculos] = useState<Vinculo[]>(info);
    const [vinculo, setVinculo] = useState<Vinculo | null>(null);
    const [vinculo2, setVinculo2] = useState<Vinculo | null>(null);
    const [vinculo3, setVinculo3] = useState<Vinculo | null>(null);
    const [send, setSend] = useState(false);
    const [thim1, setThim1] = useState(false);
    const [thim2, setThim2] = useState(false);
    const [pdfUrl, setPdfUrl] = useState('');
    const [activeTab, setActiveTab] = useState<'video' | 'pdf'>('video');

    const contentRef = useRef<HTMLDivElement>(null);

    const isFetching = useRef<string | null>(null);

    useEffect(() => {
        if (!id || vinculos.length === 0) return;

        const currentVinculo = vinculos.find((element) => Number(element.id) === Number(id));
        if (!currentVinculo) return;

        setVinculo(currentVinculo);
        setPdfUrl(currentVinculo.pdf_url || '');

        const currentIndex = vinculos.indexOf(currentVinculo);
        const prevIndex = (currentIndex === 0) ? vinculos.length - 1 : currentIndex - 1;
        const nextIndex = (currentIndex === vinculos.length - 1) ? 0 : currentIndex + 1;

        setVinculo2(vinculos[prevIndex]);
        setVinculo3(vinculos[nextIndex]);

        if (!currentVinculo.contenido && isFetching.current !== id) {
            isFetching.current = id;

            let formData = new FormData();
            formData.append("idContenido", currentVinculo.id);

            fetch(`${API_BASE_URL}/cliente.php`, {
                method: "POST",
                body: formData
            })
                .then(response => response.json())
                .then(data => {
                    const updatedVinculo = {
                        ...currentVinculo,
                        contenido: converHtml(data.resp),
                        pdf_url: data.pdf_url || '',
                        numero_visitas: currentVinculo.numero_visitas + 1
                    };

                    setVinculo(updatedVinculo);
                    setPdfUrl(data.pdf_url || '');

                    const updatedVinculos = vinculos.map(v => v.id === updatedVinculo.id && v.id_tipo_perfil === updatedVinculo.id_tipo_perfil ? updatedVinculo : v);
                    setVinculos(updatedVinculos);

                    localStorage.setItem("data", JSON.stringify({
                        vinculos: updatedVinculos,
                        perfil: context?.data?.perfil,
                        secciones: context?.data?.secciones,
                        isSoporte: context?.data?.isSoporte,
                    }));

                    context?.setData((prevData: any) => ({
                        ...prevData,
                        vinculos: updatedVinculos,
                    }));

                    sendVisit(currentVinculo.id, "numero_visitas");
                })
                .catch((err) => {
                    console.error("Error cargando contenido:", err);
                })
                .finally(() => {
                    isFetching.current = null;
                });
        }
    }, [id, vinculos]);

    useEffect(() => {
        if (activeTab !== 'video' || !contentRef.current) return;
        const video = contentRef.current.querySelector('video');
        if (!video) return;

        const tryFullscreen = () => {
            if (video.requestFullscreen) {
                video.requestFullscreen().catch(() => { });
            } else if ((video as any).webkitEnterFullscreen) {
                (video as any).webkitEnterFullscreen();
            } else if ((video as any).msRequestFullscreen) {
                (video as any).msRequestFullscreen();
            }
        };

        const handlePlay = () => tryFullscreen();

        video.addEventListener('play', handlePlay);

        if (!video.paused) {
            tryFullscreen();
        }

        return () => {
            video.removeEventListener('play', handlePlay);
        };
    }, [activeTab, vinculo?.contenido]);

    const llegada = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        let href = (event.target as HTMLElement).getAttribute('href');
        if (href) {
            navigate(href);
        }
    };

    const sendVotePos = () => {
        setThim1(true);
        setThim2(false);
        setSend(true);
        sendVisit(vinculo?.id || '', "voto_positivo");
    };

    const sendVoteNeg = () => {
        setThim1(false);
        setThim2(true);
        setSend(true);
        sendVisit(vinculo?.id || '', "voto_negativo");
    };

    const sanitizedData = (data: string) => {
        return {
            __html: DOMPurify.sanitize(data, {
                ADD_TAGS: ['iframe', 'video', 'source'],
                ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling', 'src', 'width', 'height', 'autoplay', 'muted', 'loop', 'controls']
            })
        };
    };

    if (!vinculo) return (
        <div className="view-container fadeIn">
            <div className="view mb-4">
                <div className="migas">
                    <Button onClick={() => navigate(-1)} className="!rounded-3xl" >
                        <FaChevronLeft className="i" style={{ marginRight: '5px' }} />
                        Volver al inicio
                    </Button>
                </div>
            </div>
            <span>No se encontró la información del vínculo</span>
        </div>
    );

    return (
        <div className="view-container fadeIn lg:px-margin-desktop">
            <div className="view mb-2">
                <div className="migas">
                    <Button onClick={() => navigate(-1)} className="!rounded-3xl" >
                        <FaChevronLeft className="i" style={{ marginRight: '5px' }} />
                        Volver
                    </Button>
                </div>
                <div className="num"><FaEye className="i" /> Visto {vinculo.numero_visitas} veces</div>
            </div>
            <div className="viewV">
                <h1 className="text-pegasus">{vinculo?.titulo}</h1>

                {pdfUrl && (
                    <div className="flex gap-2 mb-4" style={{ borderBottom: '2px solid #e0e0e0', paddingBottom: '8px' }}>
                        <button
                            onClick={() => setActiveTab('video')}
                            className={`px-4 py-2 rounded-3xl border-none cursor-pointer text-sm font-bold transition-colors ${activeTab === 'video' ? 'bg-primary text-white' : 'bg-gray-100 text-on-surface-variant hover:bg-gray-200'}`}
                        >
                            Video
                        </button>
                        <button
                            onClick={() => setActiveTab('pdf')}
                            className={`px-4 py-2 rounded-3xl border-none cursor-pointer text-sm font-bold transition-colors ${activeTab === 'pdf' ? 'bg-primary text-white' : 'bg-gray-100 text-on-surface-variant hover:bg-gray-200'}`}
                        >
                            Documento PDF
                        </button>
                    </div>
                )}

                {activeTab === 'video' && (
                    <div ref={contentRef} className="contenido" dangerouslySetInnerHTML={sanitizedData(vinculo?.contenido || '')} onClick={llegada} />
                )}

                {activeTab === 'pdf' && pdfUrl && (
                    <div className="w-full" style={{ height: '80vh' }}>
                        <iframe
                            src={pdfUrl}
                            className="w-full h-full border-0 rounded-xl"
                            title="Documento PDF"
                        />
                    </div>
                )}

                <div className="footer">
                    <div className="enlaces">
                        <div className="enlace">
                            <Link to={`/link/${vinculo2?.id}`}>
                                <div style={{ alignContent: 'center', alignItems: 'center', display: 'flex' }}>
                                    <FaAngleDoubleLeft className="i" style={{ color: "rgba(6, 82, 221, 1)" }} />
                                    {vinculo2?.id_seccion !== '0' && <span>{vinculo2?.id_seccion}.</span>}{vinculo2?.seccion}
                                </div>
                                {vinculo2?.titulo}
                            </Link>
                        </div>
                        <div className="enlace">
                            <Link to={`/link/${vinculo3?.id}`}>
                                <div style={{ alignContent: 'revert', alignItems: 'center', display: 'flex' }}>
                                    {vinculo3?.id_seccion !== '0' && <span>{vinculo3?.id_seccion}.</span>}{vinculo3?.seccion}
                                    <FaAngleDoubleRight className="i" style={{ color: "rgba(6, 82, 221, 1)" }} />
                                </div>
                                {vinculo3?.titulo}
                            </Link>
                        </div>
                    </div>
                    <div className={`like fadeIn ${send ? 'hidden' : ''}`}>
                        <h4 className="text-pegasus">¿Le resultó útil ésta información?</h4>
                        <div className="iconos">
                            <FaThumbsUp className={`${thim1 ? 'text-pegasus' : 'text-down'} i`} onClick={sendVotePos} />
                            <FaThumbsDown className={`${thim2 ? 'text-pegasus' : 'text-down'} i`} onClick={sendVoteNeg} />
                        </div>
                    </div>
                    {send && <div className="fadeIn tenks text-pegasus">¡Gracias por su opinión!</div>}
                </div>
            </div>
        </div>
    );
};

export default View;
